<template>
  <div class="contact-modal" v-if="visible">
    <div class="contact-box">
      <button class="modal-close" @click="handleClose">✕</button>
      <h3 class="modal-title">扫码添加微信</h3>
      <div class="modal-qrcode" @click="copyWechat" title="点击复制微信号">
        <img src="@/assets/qrcode.png" alt="微信二维码" />
        <div class="modal-tip">点击复制微信号</div>
      </div>
      <p class="modal-wechat">微信号：<span>Gk_Coding</span></p>
      <p class="modal-note">添加请备注来源信息<br/>B站/小红书/朋友推荐 等</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    copyWechat() {
      navigator.clipboard.writeText('Gk_Coding').then(() => {
        this.$message({ message: '微信号已复制：Gk_Coding', type: 'success', duration: 2000 })
      }).catch(() => {
        this.$message({ message: '复制失败，请手动输入：Gk_Coding', type: 'warning', duration: 2000 })
      })
    }
  }
}
</script>

<style scoped>
.contact-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 20px;
}

.contact-box {
  background: #fff;
  padding: 32px 40px;
  text-align: center;
  position: relative;
  min-width: 280px;
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 18px;
  color: #9ca3af;
  cursor: pointer;
}

.modal-close:hover {
  color: #374151;
}

.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 20px;
}

.modal-qrcode {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-bottom: 16px;
}

.modal-qrcode img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
}

.modal-tip {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 12px;
  padding: 3px 10px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}

.modal-qrcode:hover .modal-tip {
  opacity: 1;
}

.modal-wechat {
  font-size: 14px;
  color: #6b7280;
  margin: 12px 0 0;
}

.modal-wechat span {
  color: #2563eb;
  font-weight: 600;
}

.modal-note {
  font-size: 13px;
  color: #2563eb;
  margin: 12px 0 0;
  line-height: 1.6;
  font-weight: 500;
}
</style>
